import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["headerHeight", "onClose", "onNavItemBack", "onNavItemClick", "openItems", "open", "onNavItemHover"];
import React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { SideNavMenu } from './SideNavMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export function SideNavPopover(props) {
  var headerHeight = props.headerHeight,
    onClose = props.onClose,
    onNavItemBack = props.onNavItemBack,
    onNavItemClick = props.onNavItemClick,
    _props$openItems = props.openItems,
    openItems = _props$openItems === void 0 ? [] : _props$openItems,
    open = props.open,
    onNavItemHover = props.onNavItemHover,
    others = _objectWithoutProperties(props, _excluded);
  return open ? /*#__PURE__*/_jsx(StyledStack, _extends({
    direction: "row"
  }, others, {
    children: openItems.map(function (openItem, index) {
      var level = index + 1;
      return /*#__PURE__*/_jsx(SideNavMenu, {
        "data-testid": "".concat(openItem.key),
        level: level,
        navItem: openItem,
        onClose: onClose,
        onNavItemBack: onNavItemBack,
        onNavItemClick: onNavItemClick,
        onNavItemHover: onNavItemHover
      }, openItem.key);
    })
  })) : null;
}
var StyledStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiMenuItem-root:hover': {
      backgroundColor: "".concat(theme.palette.primary[50], " !important")
    },
    backgroundColor: theme.palette.common.white,
    borderLeft: "ridge 0.5px ".concat(theme.palette.grey[300]),
    height: '100%',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zindex: 2000
  };
});